import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { AdminPanel } from '@/components/admin/AdminPanel';
import { useAuthStore } from '@/stores';
import { Loader2 } from 'lucide-react';

export default function Admin() {
  const { user, isAuthenticated } = useAuthStore();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await fetch('https://memories-api.haliagav.workers.dev/api/auth/me', {
          credentials: 'include',
        });
        const data = await response.json();

        if (!data.success || data.user?.role !== 'admin') {
          return;
        }
      } catch {
        return;
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!isAuthenticated || user?.role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  return <AdminPanel />;
}